// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ddBeMmQ9Wi7JZC {
  display: flex;
  box-sizing: border-box;
  flex-direction: column;
  height: 90vh;
  max-height: 680px;
  padding: var(--ds-space-300, 24px) var(--ds-space-300, 24px) var(--ds-space-0, 0);
  row-gap: var(--ds-space-200, 16px);
}
.ddBeMmQ9Wi7JZC .GjzzL6jp0a29Fo {
  flex: 1;
  margin: var(--ds-space-0, 0) var(--ds-space-negative-300, -24px);
  padding: var(--ds-space-0, 0) var(--ds-space-300, 24px) var(--ds-space-300, 24px);
  overflow-x: hidden;
  overflow-y: auto;
  scrollbar-width: none;
}
.ddBeMmQ9Wi7JZC.A8aZRCqYPmIY3v {
  height: 100%;
  max-height: unset;
  padding: unset;
}
.ddBeMmQ9Wi7JZC.A8aZRCqYPmIY3v .GjzzL6jp0a29Fo {
  margin: unset;
  padding: var(--ds-space-0, 0) var(--ds-space-0, 0) var(--ds-space-075, 5px) var(--ds-space-0, 0);
  scrollbar-width: unset;
}
.ddBeMmQ9Wi7JZC.DJbjNixZd2co14 {
  justify-self: center;
  max-width: 640px;
  padding-bottom: var(--ds-space-1000, 80px);
}
@media screen and (max-width: 640px) {
  .ddBeMmQ9Wi7JZC.DJbjNixZd2co14 {
    max-width: 100%;
  }
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"boardSwitcher": `ddBeMmQ9Wi7JZC`,
	"scrollContainer": `GjzzL6jp0a29Fo`,
	"panel": `A8aZRCqYPmIY3v`,
	"singlePanel": `DJbjNixZd2co14`
};
export default ___CSS_LOADER_EXPORT___;
